export default __webpack_public_path__ + "static/media/signature-new.af5e8453.svg";